module.exports = __webpack_public_path__ + "img/icon-tray.f5fe190f.svg";